import { default as default_country_codes } from '../common/default_country_codes';
import { default as country_codes } from '../common/country_codes';

export default {
  getIcons({ commit }) {
    const icons = {};

    const requireComponents = require.context(
      '../assets/flags/',
      false,
      /.svg$/
    );
    requireComponents.keys().forEach(fileName => {
      const iconName = fileName.replace(/^\.\/(.+)\.svg$/, '$1');
      const componentConfig = requireComponents(fileName);
      icons[iconName] = componentConfig.default || componentConfig;
    });

    commit('setIcons', icons);

    return icons;
  },

  getSelectItems({ commit }) {
    let countryCodes = [
      ...default_country_codes,
      { divider: true },
      ...country_codes.sort((a, b) => a.country.localeCompare(b.country))
    ];
    countryCodes.forEach((o, i) => o.id = i + 1);

    commit('setSelectItems', countryCodes);

    return countryCodes;
  }
};
